<app-modal [title]="titreModale()" size="md" closeLabel="Fermer" (closed)="annuler()">
  <div class="dialog-content flex">
    <div class="content_text">
      <div [innerHtml]="infoDialog().message"></div>
    </div>

    <div class="content_input">
      <!-- Les deux panneaux etaient SUPERPOSES en absolu, un `translateX`
           d'animation ecartant celui de creation. Ils sont desormais
           EXCLUSIFS : un seul existe a la fois, sans dependre du moteur
           d'animations ni d'un empilement. -->
      @if (!creerCompteBancaire()) {
        <div class="content_confirm">
          @if (infoDialog().actionEstBLoquee) {
            <app-alert variant="warning">{{ infoDialog().infoBlocageMessage }}</app-alert>
          } @else {
            @if (infoDialog().type === 'acompte') {
              <app-form-field label="Montant de l'acompte" [required]="true" class="form_field">
                <!-- `InputType` du kit n'a pas `number` (manque A14) : saisie numérique
                   via `inputMode` + filtre de caractères. -->
                <app-input
                  inputMode="decimal"
                  [allowedChars]="chiffres"
                  suffix="€"
                  [formControl]="montantAcompte"
                  (committed)="normaliserMontant(montantAcompte)"
                />
                @if (montantAcompteSuivi().hasError('required')) {
                  <span appFieldError>Le montant est obligatoire</span>
                }
                @if (montantAcompteSuivi().hasError('min')) {
                  <span appFieldError>Le montant minimum est de 1€</span>
                }
                @if (montantAcompteSuivi().hasError('valideMontant')) {
                  <span appFieldError>Le montant maximum est de {{ infoDialog().MontantMaxAcompte | devise }}</span>
                }
              </app-form-field>
            }

            <!-- Le déclencheur de `mat-select` affichait le titulaire, l'option affichait
               titulaire + IBAN sur deux lignes. `SelectOption` couvre les deux :
               `label` porte le titulaire, `suffix` l'IBAN. -->
            <app-form-field label="Compte bancaire" class="form_field">
              <app-select
                label="Sélectionner un compte"
                trigger="field"
                [clearable]="true"
                selectionMode="single"
                [fullWidth]="true"
                [options]="optionsComptes()"
                [selected]="comptesSelectionnes()"
                (selectionChange)="choisirCompte($event)"
              />
              @if (ibanSelectionne(); as iban) {
                <span appFieldHint>{{ iban }}</span>
              }
            </app-form-field>

            <button type="button" appButton variant="link" class="ajout_compte" (click)="toggle()">
              Ajouter un compte bancaire
            </button>
          }
        </div>
      }

      @if (creerCompteBancaire()) {
        <div class="content_compteBancaire">
          <form [formGroup]="compteBancaireForm">
            <app-form-field label="Titulaire" [required]="true" class="form_field">
              <app-input formControlName="nomTitulaire" />
              @if (compteBancaireFormSuivi().controls.nomTitulaire.hasError('required')) {
                <span appFieldError>Le titulaire est obligatoire</span>
              }
              @if (compteBancaireFormSuivi().controls.nomTitulaire.hasError('minlength')) {
                <span appFieldError>La longueur minimum est de 3 caractères</span>
              }
            </app-form-field>

            <!-- Le formatage (groupes de 4, majuscules) est appliqué AU CONTRÔLE et non
               plus au seul affichage : les validateurs tolèrent les espaces (`\s?`) et
               le submit les retire. Le modèle et l'affichage ne peuvent plus diverger. -->
            <app-form-field label="Iban" [required]="true" class="form_field">
              <app-input formControlName="iban" placeholder="CP00 0000 0000 0000 0000..." />
              @if (compteBancaireFormSuivi().controls.iban.hasError('required')) {
                <span appFieldError>L'iban est obligatoire</span>
              } @else if (compteBancaireFormSuivi().controls.iban.hasError('pattern')) {
                <span appFieldError>Le format de l'iban n'est pas correct</span>
              } @else if (compteBancaireFormSuivi().controls.iban.hasError('ValideIban')) {
                <span appFieldError>L'iban n'est pas correct pour ce pays</span>
              }
            </app-form-field>

            <app-form-field label="BIC" [required]="true" class="form_field">
              <app-input formControlName="bic" placeholder="AAAA BB 1C 12D" />
              @if (compteBancaireFormSuivi().controls.bic.hasError('required')) {
                <span appFieldError>Le bic est obligatoire</span>
              }
              @if (compteBancaireFormSuivi().controls.bic.hasError('pattern')) {
                <span appFieldError>Le format du bic n'est pas correct</span>
              }
            </app-form-field>

            <div class="btn_liste flex">
              <button type="button" appButton variant="secondary" class="flex-1" (click)="toggle()">Annuler</button>
              <button
                type="button"
                appButton
                variant="primary"
                class="flex-1"
                [disabled]="compteBancaireFormSuivi().invalid"
                (click)="ajouterComtpeBancaire()"
              >
                Créer le compte bancaire
              </button>
            </div>
          </form>
        </div>
      }
    </div>
  </div>

  <div appModalFooter>
    <button type="button" appButton variant="ghost" (click)="annuler()">{{ infoDialog().btnAnnuler }}</button>
    <button type="button" appButton variant="primary" [disabled]="isValid()" (click)="SubmitValue()">
      {{ infoDialog().btnValide }}
    </button>
  </div>
</app-modal>
